<template>
  <div class="absolute top-0 bottom-0 left-0 right-0 z-[2000] px-3 py-2 bg-white">
    <div class="flex items-center justify-end w-full mb-4">
      <button class="flex flex-col items-center justify-center pt-2" type="button" @click="closeSearchMenu" @keydown.esc="closeSearchMenu" data-testid="mobileMenuCloseSearchMenuButton">
        <img width="18" height="18" class="inline top-mobile-icons" src="../../../assets/images/cross-black.svg" alt="close menu" />
        <span class="whitespace-nowrap text-black mt-0.5 leading-4 uppercase font-futuraEfDemiBold text-[0.6875rem]">{{ translations?.topMenuMobile.closeMenu }}</span>
      </button>
    </div>
    <form name="searchform" :action="searchPageUrl" data-testid="mobileMenuSearcForm">
      <ellevio-web-header-search-input
        :apiUrl="searchApiUrl"
        :searchNoHitsContent="searchNoHitsContent"
        :label="translations?.search?.inputLabel"
        :placeholder="translations?.search?.inputPlaceholder"
        buttonText="Sök"
        :itemIsOpen="true"
        :clearSearchFieldLabel="translations?.search?.clearSearchField" />
    </form>
    <div class="flex flex-col items-center mb-7"></div>
  </div>
</template>

<script>
import EllevioWebHeaderSearchInput from '../vue-components/HeaderSearchInput.vue'
export default {
  name: 'EllevioWebMobileSearchWideArea',
  components: {
    EllevioWebHeaderSearchInput
  },
  props: {
    login: {
      type: Object,
      default: () => {}
    },
    myPages: {
      type: Boolean,
      default: false
    },
    userLoggedIn: {
      type: Boolean,
      default: false
    },
    searchApiUrl: {
      type: String,
      default: ''
    },
    searchPageUrl: {
      type: String,
      default: ''
    },
    searchNoHitsContent: {
      type: String,
      default: ''
    },
    translations: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    closeSearchMenu() {
      this.$emit('close-search-menu')
    },
    objectEmpty(obj) {
      return typeof obj === 'undefined' || (Object.keys(obj).length === 0 && obj.constructor === Object)
    }
  }
}
</script>
